import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';

@Component({
  selector: 'coin-siemens-energy-faq-help-desk-level',
  templateUrl: './faq-help-desk-level.component.html',
  styleUrls: ['./faq-help-desk-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FaqHelpDeskLevelComponent {
  faqItem = input<FaqItem>();
  openFaq = output<FaqDrill>();

  public openHelpdesk(): void {
    window.open(environment.helpdeskUrl, '_blank');
  }
}
